// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "td .icon-with-text{display:flex;align-items:center}td.text-xs-right .icon-with-text{justify-content:flex-end}tbody tr:not(:first-child) td.orange.lighten-3,tbody tr:not(:first-child) td.red.lighten-3{border-top:1px solid #e0e0e0!important;border-top-color:#e0e0e0!important}", ""]);
// Exports
module.exports = exports;
